import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Image as PDFImage
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';
const fullScreenStyles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1000,
        backgroundColor: 'white'
    }
};

const styles = StyleSheet.create({
    page: {
        padding: 20,
        paddingTop: '2%',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    text: {
        fontSize: 10
    },
    textUnderlined: {
        fontSize: 9,
        textDecoration: 'underline'
    },
    heading: {
        fontSize: 14,
        fontWeight: 'ultrabold',
        marginBottom: 10,
        textAlign: 'center'
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: 40,
        width: '95vw',
        border: "1px solid black ",
        borderRadius: "10px",
        paddingTop: "10px",
        paddingLeft: "60px",
        paddingRight: "20px",
        paddingBottom: "5%"

    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        marginRight: "10px"

    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        gap: '0.5rem'
    },
    signatory: {
        marginTop: "5%",
        width: "100%",
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "space-evenly"

    }
});

const Page = ({ style, children, ...props }) => (
    <PDFPage style={{ ...styles.page, ...style }} {...props}>
        {children}
    </PDFPage>
);

const View = ({ style, children, ...props }) => (
    <PDFView style={{ ...style }} {...props}>
        {children}
    </PDFView>
);

const Text = ({ style, content, ...props }) => (
    <PDFText style={{ ...styles.text, ...style }} {...props}>
        {content}
    </PDFText>
);

export const PatientDischargePdf = ({ data }) => {
    console.log("Hello Data", data)
    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    return (
        <div style={fullScreenStyles.container}>
            <PDFViewer width="100%" height="100%" showToolbar>
                <Document title={`${data.name} Discharged`}>
                    <Page size="A4" style={styles.page}>
                        <PDFImage
                            src="/logo_Hospital_m.jpeg"
                            style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
                        />

                        <Text content="Gate Pass" />
                        <View style={styles.contentContainer}>
                            <View style={styles.column}>
                                <View style={styles.row}>
                                    <Text content="UHID NO.        :- " style={{ fontSize: 9, fontWeight: 'bold' }} />
                                    <Text content={`${data.uhid}`} />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Name              :- " style={{ fontSize: 9 }} />
                                    <Text content={`${data.name}`} />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Doctor             :-    " style={{ fontSize: 9 }} />
                                    <Text content={`${data.consultant}`} />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Department     :- " style={{ fontSize: 9 }} />
                                    <Text content={`${data.department}`} />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Address           :-  " style={{ fontSize: 9 }} />
                                    <Text content={`${data.address}`} />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Ward/Bed No.  :- " style={{ fontSize: 9 }} />
                                    <Text content={`${data.ward_name}/${data.bed_no}`} />
                                </View>
                            </View>
                            <View style={styles.column}>
                                <View style={styles.row}>
                                    <Text content="IPD No                     :- " style={{ fontSize: 9 }} />
                                    <Text content={`${data.ipd_no}`} />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Bill No.                     :- " style={{ fontSize: 9 }} />
                                    <Text content="" />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Bill Date                   :- " style={{ fontSize: 9 }} />
                                    <Text content="" />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Addmission Date     :- " style={{ fontSize: 9 }} />
                                    <Text content={`${formatDate(data.indoorcreatedAt)} ${(data?.time)}`} />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Discharge Date       :-  " style={{ fontSize: 9 }} />
                                    <Text content={`${dateFormatter(data.dischargeDate)}${(data.dischargeTime)}`} />
                                </View>
                                <View style={styles.row}>
                                    <Text content="Sponsor                   :- " style={{ fontSize: 9 }} />
                                    <Text content={`${data.sponsor}`} />
                                </View>
                            </View>
                        </View>
                        <div style={styles.signatory}>
                            <Text content="Lab                    " style={{ fontSize: 9 }} />
                            <Text content="Pharmacy                    " style={{ fontSize: 9 }} />
                            <Text content="Pharmacy                    " style={{ fontSize: 9 }} />
                        </div>
                    </Page>
                </Document>
            </PDFViewer>
        </div >
    );
};
